import React from 'react'
import { Link } from 'react-router-dom'
import { ellips, shield } from '../../../assets'

const Verification = () => {
  return (
    <>
            <img className="absolute top-[40%] left-[15%] z-0 md:left-[42%]" src={ellips} alt="" />
    <div className='flex flex-col z-10 mb-[100px]'>
        <div className='flex flex-col mt-[100px] justify-center items-center'>
            <img className='w-[55px] h-[66px]' src={shield} alt="" />
            <div className='font-sans text-[20px] mt-[23px]'>Verification</div>
        </div>
        <div className='flex flex-col justify-center mt-[165px] items-center'>
            <Link to='/numver' className='bg-gray-inputGray font-[Poppins] text-[18px] mt-[9px] color-gray-lightGray w-[213px] text-gray-lightGray flex cursor-pointer justify-center items-center h-[40px]'>Continue with phone</Link>
            <div className='mt-[9px] font-[Poppins] text-[18px]'>or</div>
            <Link to='/emailver' className='bg-gray-inputGray font-[Poppins] text-[18px] mt-[9px] color-gray-lightGray w-[213px] text-gray-lightGray flex cursor-pointer justify-center items-center h-[40px]'>Continue with email</Link>
        </div>
        <div className='flex flex-col justify-center font-[Poppins] items-center mt-[100px] text-white cursor-pointer h-[39px] bg-blue-chatBlue'>Back</div>
    </div>
    </>
  )
}

export default Verification